import './Home.scss'
import { Row, Col, ModalPopup,Breadcrumb, Card, Tabs, EventHandler } from '../../../CommonComponents'
import CreateNewOrder from './CreateNewOrder'
import MyNotificationNew from './MyNotification-New'
import MyAlertNew from './MyAlert-New'
import CreateNewOrderIcon from '../../../assets/images/New Order.svg'
import OrderTypePopup from './OrdertypePopup'
import permissions, { ACCESS_DENIED, isAuthorized } from 'client/utils/Permissions'
import {Tooltip} from 'client/CommonComponents'
import CreateNewRequestIcon from '../../../assets/images/New Asset Request.svg'

interface IProps {
  showOrderTypePopup?:boolean
  hidePopup?:any
  ShowPopup?:any
  setModalDisplay?: any;
  showModal?: boolean;
  breadcrumlist?: any;
  CreateNewRequisitionHandleClick?:any;
  wrapperRef?: any;
  Popupcontent?:any,
  CreateNewRequestHandleClick?:any,
  myAlertDetails?: any,
  myNotificationDetails?: any,
  showGridPanel?: any,
  hidePanel?: any,
  showPanel?: any
}

const Home = ({CreateNewRequisitionHandleClick, 
  showOrderTypePopup,
  hidePopup, 
  setModalDisplay, 
  showModal, 
  breadcrumlist, 
  CreateNewRequestHandleClick, 
  myAlertDetails, 
  myNotificationDetails, 
  showGridPanel,
  hidePanel,
  showPanel}:IProps) => {
  const modalPopupName = () => {
    if(showModal){
     return("");
    }else{
      return("order-type");
    }
 }


 const alertItems = [
  {
    headerText: `My Alerts ${myAlertDetails?.alertCount ? `(` + myAlertDetails?.alertCount + `)`: ""}`,
    content: <MyAlertNew/>,
  },
  {
    headerText: `My Notifications ${myNotificationDetails?.notificationCount ? `(` + myNotificationDetails?.notificationCount + `)` : ''}`,
    content: <MyNotificationNew/>,
  }
];

  return <>
    <div>
      <div className='breadcrumb-toolbar pull-left home-screen-breadcrumb'>
        <div className='create-asset-btnBlock'>
          <button disabled={!(isAuthorized(permissions.ViewTransfers) || !isAuthorized(permissions.RequisitionsCreateUpdate))} className='create-new-order-btn me-2' title={!(isAuthorized(permissions.ViewTransfers) || !isAuthorized(permissions.RequisitionsCreateUpdate)) ? ACCESS_DENIED : 'Create New Requisition'} onClick={CreateNewRequisitionHandleClick} data-attribute="Home_Default_Button_3"><img src={CreateNewOrderIcon} alt='btn-icon'/><span>Create New Requisition</span></button>
          <button disabled={!(isAuthorized(permissions.RequisitionsView) || !isAuthorized(permissions.CreateUpdateTransfers))} className='create-new-order-btn me-2' title={!(isAuthorized(permissions.RequisitionsView) || !isAuthorized(permissions.CreateUpdateTransfers)) ? ACCESS_DENIED : 'Manage Existing Assets'} onClick={CreateNewRequestHandleClick} data-attribute="Home_Default_Button_4"><img src={CreateNewRequestIcon} alt='btn-icon'/><span>Manage Existing Assets</span></button>      
        </div>
        <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="Home_Default_Breadcrumb_2" /></div>
      </div>
    </div>
    
    <Row className='home-block mx-0'>
      <div className={showGridPanel ? "alertsNotifyToggle" : "alertsNotifyToggle toggleopposite"} >
              {
                  showGridPanel ? <EventHandler onEvent={hidePanel} data-attribute="Home_Default_EventHandler_3">
                      <span className="fa fa-angle-double-left" ></span> </EventHandler>:
            <Tooltip content='Alerts & Notification' data-attribute="Home_Default_Tooltip">
                          <EventHandler onEvent={showPanel} data-attribute="Home_Default_EventHandler_2_2"> <span className="fa fa-bell-o"><span className="notify-badge">{(myAlertDetails?.alertCount || myAlertDetails?.notificationCount) ? myAlertDetails?.alertCount + myAlertDetails?.notificationCount : 0}</span></span></EventHandler>
            </Tooltip>
        }
      </div>
      {
        showGridPanel ? <Col xs={12} sm={12} md={12} lg={4} xl={4} className='order-2 ps-sm-0 pe-sm-3 px-0'>
        <div className="alertsNotifySection">
          <Card data-attribute="Home_Default_Card_2">
            <Tabs tabItems={alertItems}  data-attribute="Home_Default_Tabs" />
            
          </Card>
        </div>
      </Col>
        : ""
      }

      <Col xs={12} sm={12} md={12} lg={showGridPanel?8:12} xl={showGridPanel?8:12} className='mb-4 mb-lg-0 order-1 pe-sm-0 px-0'>
        <div className='right-block'>
          <CreateNewOrder/>
        </div>
      </Col>
      
    </Row>
    {
      showOrderTypePopup
      ? <ModalPopup
            ShowModalPopupFooter={false}
            ModalPopupTitle="ORDER TYPE"
            ModalPopupType="small"
            closeModalPopup={hidePopup}
            ModalPopupName={modalPopupName()}
         data-attribute="Home_Default_ModalPopup">
           <OrderTypePopup setShowPopup={setModalDisplay}/>
      </ModalPopup>
      : null
    }
    </>
}

export default Home
